export type FbaProfitInput = {
  /** Amazon の現在価格（取れていない時は -1） */
  amazonPrice: number;
  /** 仕入値（税込） */
  cost: number | null | undefined;
  salesCommission: number | null | undefined;
  categoryFee: number | null | undefined;
  fbaShippingFee: number | null | undefined;
};

export type FbaProfit = {
  profitPrice: number | null;
  profitRate: number | null;
};

/**
 * FBA で売った場合の利益額と利益率（利益額 ÷ Amazon価格）。
 * 利益額 = Amazon価格 − 販売手数料 − カテゴリ成約料 − FBA配送代行手数料 − 仕入値
 * 価格・仕入値・手数料のどれかが無い時は計算せず null を返す（並べ替えでは末尾に回る）。
 */
export const calcFbaProfit = (p: FbaProfitInput): FbaProfit => {
  const values = [p.cost, p.salesCommission, p.categoryFee, p.fbaShippingFee];
  if (!(p.amazonPrice > 0) || values.some((v) => v == null)) {
    return { profitPrice: null, profitRate: null };
  }
  const profitPrice = p.amazonPrice - p.salesCommission - p.categoryFee - p.fbaShippingFee - p.cost;
  return { profitPrice, profitRate: profitPrice / p.amazonPrice };
};
